import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Stack, Typography, Button, Box } from "@mui/material";
import { alpha } from "@mui/material/styles";
import MyLocationRoundedIcon from "@mui/icons-material/MyLocationRounded";

export default function PermissionPrimerDialog({
  open,
  onEnable,
  onClose,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      closeAfterTransition
      keepMounted={false}
      TransitionProps={{ unmountOnExit: true }}
      slotProps={{ backdrop: { sx: { pointerEvents: open ? "auto" : "none" } } }}
      PaperProps={{
        sx: {
          borderRadius: 2,
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle sx={{ pb: 1.25 }}>
        <Stack spacing={1.25} alignItems="flex-start">
          <Box
            sx={(theme) => ({
              width: 44,
              height: 44,
              borderRadius: "50%",
              display: "grid",
              placeItems: "center",
              bgcolor: alpha(theme.colors.blue, 0.12),
              color: theme.colors.blue,
            })}
          >
            <MyLocationRoundedIcon />
          </Box>
          <Typography variant="h5" component="span" sx={{ fontWeight: 800, lineHeight: 1.08 }}>
            Unlock what&apos;s near you
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={1}>
          <Typography variant="body1" sx={{ fontWeight: 700 }}>
            Find hidden capsules around your actual spot.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Your map gets sharper, nearby results get better, and walking routes can start from where you are.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, pt: 1 }}>
        <Stack direction="column" spacing={1} sx={{ width: "100%" }}>
          <Button
            variant="contained"
            onClick={onEnable}
            fullWidth
            startIcon={<MyLocationRoundedIcon />}
            sx={(theme) => ({
              p: "12px 20px",
              fontWeight: 800,
              bgcolor: theme.colors.blue,
              color: theme.colors.white,
              "&:hover": {
                bgcolor: theme.colors.blue,
              },
            })}
          >
            Use my location
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
